import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { ChooseAssetsToSellAssets } from "../../../Common/SIPP/DrawdownDetails/Store/DrawdownCalculationStoreStatic";
import { DrawdownType } from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import {
    getAssetsToSellTotalForDrawdown,
    getSellableAssets,
    getUpdatedAssetsToSell,
    showChooseAssetstoSell,
} from "../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { ChooseAssetsToSellFor } from "../../../Common/SIPP/DrawdownDetails/Resource/Contents";
import { ChooseAssetsToSell } from "../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSell";
import { ChooseAssetsToSellTable } from "../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSellTable";
import { IncomeBankDetails } from "../../../Common/SIPP/IncomePaymentDetails/IncomeBankDetails";
import { setValueByKey } from "../../../../../../Shared/Table/Utils/TableUtils";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { NewlyCalculatedGADDetails } from "../../../PensionBenefitsWizard/Components/IncomePaymentDetails/CalculatedGADDetails";
import { RegularIncomePaymentDetails } from "../../../PensionBenefitsWizard/Components/IncomePaymentDetails/RegularIncomePaymentDetails";
import { OtherIncomePaymentDetails } from "../../../PensionBenefitsWizard/Components/IncomePaymentDetails/OtherIncomePaymentDetails";
import { DrawdownAnnualIncome } from "../../../../../../../Wrap/Models/Domains/Drawdown/DrawdownAnnualIncome";
import _ from "lodash";
import { DrawdownIncomeAmendmentInstruction } from "../../../../../../../Wrap/Models/Domains/Drawdown/DrawdownIncomeAmendmentInstruction";
import { TableKeys } from "../../../Common/SIPP/DrawdownDetails/Resource/Constant";

interface IIncomePaymentDetailsProps extends IProcessComponentProps {
    data: PensionContributionModel;
    type: SubAccountType;
}

interface IIncomePaymentDetailsState {
    assets: ChooseAssetsToSellAssets[];
}

export class IncomePaymentDetails extends ProcessComponent<IIncomePaymentDetailsProps, IIncomePaymentDetailsState> {
    constructor(props: any) {
        super(props);
        this.state = {
            assets: [],
        };
    }

    private getSellableAssets = () => {
        const params = getQueryParameters();
        const hierarchyId = params["hierarchyid"];
        SubAccountTypeHelper.getSubAccountHierarchyId(hierarchyId, SubAccountType.Npr, (subAccountHierarchyId) => {
            getSellableAssets(this.props.type, hierarchyId, subAccountHierarchyId, (data) => {
                let usedTotal = getAssetsToSellTotalForDrawdown(this.props.data?.Contribution?.DrawdownModel);
                let updateAssets = getUpdatedAssetsToSell(
                    this.props.data?.Contribution?.DrawdownModel.PensionCommencementLumpSumAllocations,
                    usedTotal,
                    data?.assetsToSell
                );
                this.setState({ assets: updateAssets });
            });
        });
    };

    componentDidMount() {
        super.componentDidMount();
        this.getSellableAssets();
    }

    private getContributionProps = (data: PensionContributionModel, onChange) => {
        return {
            data: data?.Contribution,
            onChange: (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
        };
    };

    private getDrawdownModelProps = (data: PensionContributionModel, onChange) => {
        return {
            data: data?.Contribution?.DrawdownModel,
            onChange: (v) =>
                this.onDataChange(
                    (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                    v,
                    data.Contribution,
                    "DrawdownModel"
                ),
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
        };
    };

    private onAnnualIncomeChange = (
        drawdownModelAnnualIncome: DrawdownAnnualIncome,
        amendmendModelAnnualIncome: DrawdownAnnualIncome
    ) => {
        const { data, onChange } = this.props;
        var clonedContribution = _.cloneDeep(data.Contribution);

        if (drawdownModelAnnualIncome) {
            clonedContribution.DrawdownModel.Income = drawdownModelAnnualIncome;
        }

        if (amendmendModelAnnualIncome) {
            clonedContribution.DrawdownIncomeAmendmentModel.DrawdownIncomeAmendmentInstruction.Income = amendmendModelAnnualIncome;
        }

        onChange({ Contribution: clonedContribution });
    };

    showChooseAssetsToSellTable() {
        const { data } = this.props;
        return (
            data?.Contribution?.DrawdownModel?.IsAcrossAllAssets == false ||
            !isNullOrEmpty(data?.Contribution?.DrawdownModel?.IncomeDisinvestmentAllocations)
        );
    }

    private onDrawdownIncomeAmendmentInstructionChange = (changes: DrawdownIncomeAmendmentInstruction) => {
        const { data, onChange } = this.props;
        this.onDataChange(
            (v) => this.onDataChange(onChange, v, data, "Contribution"),
            changes,
            data.Contribution,
            "DrawdownIncomeAmendmentModel"
        )
    };

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        const drawdownType = data?.Contribution?.DrawdownModel?.DrawdownType;

        return (
            <>
                {<h2>Income payment details</h2>}

                {!(data?.Contribution?.DrawdownModel?.ImmediateTaxFreeCashRequestId && data?.Contribution?.DrawdownModel?.TaxFreeLumpSum?.Amount > 0) && <>
                {drawdownType === DrawdownType.Capped && (
                    <NewlyCalculatedGADDetails {...this.getContributionProps(data, onChange)} />
                )}
                {drawdownType === DrawdownType.Regular ? (
                    <RegularIncomePaymentDetails
                        {...this.getDrawdownModelProps(data, onChange)}
                        pensionBase={data.Contribution}
                        sellableAssets={this.state.assets}
                    />
                ) : (
                    <OtherIncomePaymentDetails
                        {...this.getDrawdownModelProps(data, onChange)}
                        onAnnualIncomeChange={(c, v) => this.onAnnualIncomeChange(c, v)}
                        pensionBase={data.Contribution}
                        drawdownIncomeReviewDetails={data?.Contribution?.DrawdownIncomeReviewDetails}
                        onDrawdownIncomeAmendmentInstructionChange={(changes)=>this.onDrawdownIncomeAmendmentInstructionChange(changes)}
                        sellableAssets={this.state.assets}
                    />
                )}
                {showChooseAssetstoSell(data.Contribution.DrawdownModel, ChooseAssetsToSellFor.Income) && (
                    <>
                        <hr />
                        <ChooseAssetsToSell
                            {...this.getDrawdownModelProps(data, onChange)}
                            tableKey={TableKeys.IncomeDisinvestmentAllocations}
                            reason={ChooseAssetsToSellFor.Income}
                            assets={this.state.assets}
                        />
                        {this.showChooseAssetsToSellTable() && (
                            <ChooseAssetsToSellTable
                                data={data?.Contribution?.DrawdownModel?.IncomeDisinvestmentAllocations}
                                tableData={this.state.assets}
                                modelData={data?.Contribution?.DrawdownModel}
                                onRef={(ref) => this.appendChild(ref)}
                                showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                onChange={(v) => {
                                    this.onDataChange(
                                        (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                        { IncomeDisinvestmentAllocations: v },
                                        data.Contribution,
                                        "DrawdownModel"
                                    );
                                }}
                                processType={ProcessType.TakePensionBenefits}
                                reason={ChooseAssetsToSellFor.Income}
                                isAcrossAllAssets={data?.Contribution?.DrawdownModel?.IsAcrossAllAssets}
                            />
                        )}
                    </>
                )}
                <hr />
                </>}
                <IncomeBankDetails
                    data={data?.Contribution?.DrawdownModel?.Income?.IncomePaymentAllocations || []}
                    onChange={(value) => {
                        onChange(
                            setValueByKey(data, "Contribution.DrawdownModel.Income.IncomePaymentAllocations", value)
                        );
                    }}
                    showErrorMsgPopUp={(msg, isShow) => this.props.showErrorMsgPopUp(msg, isShow)}
                    onRef={(ref) => this.appendChild(ref)}
                    allBankAccounts={data?.AllBankAccounts}
                    showPropotionOfIncome={data?.Contribution?.DrawdownModel?.Income?.TaxableIncomeRequiredInAddition}
                />
            </>
        );
    }
}
